// extracted by mini-css-extract-plugin
export default {"homeContainer":"HomeNew_homeContainer__ZSLX2","kong":"HomeNew_kong__xty2b","float-around":"HomeNew_float-around__JTYqn"};